import React from 'react';

const Footer = () => (
  <div className="bg-dark text-white rounded-bottom p-4">
    <h5 className="mb-3">Offer Terms &amp; Conditions</h5>
    <ol className="m-0">
      <li>The discount can be redeemed online or over the phone by calling 0330 159 1111</li>
      <li>Cannot be used in conjunction with any other offer and may be withdrawn at any time</li>
      <li>No cash or other alternatives available</li>
    </ol>
  </div>
);

export default Footer;
